/**
 * Leads Arche Page
 *
 * Route wrapper: ArcheLayout + Routes for the Leads arche.
 */

import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { LeadsPage } from './LeadsPage';

export function LeadsArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/*" element={<LeadsPage />} />
      </Routes>
    </ArcheLayout>
  );
}
